<template>
    <div>
        <transition name="slide">
            <div class="mobile-sidebar">
                <!-- <router-link to="/index">>
                    
                </router-link> -->
                <div class="sidebar-header">
                    <h3 style="cursor:pointer;color:var(--primary)" @click="jumpHome()">XIATECH 夏溪仪器</h3>
                    <button class="close-btn" @click="$emit('toggle-MobileMenu')">
                        <i class="iconfont icon-close"></i>
                    </button>
                </div>
                <nav class="mobile-nav">
                    <!-- <router-link v-for="item in navItems" :key="item.id" :to="item.path" class="nav-item"
                        @click.native="$emit('toggle-MobileMenu')"
                        @click="getMenuItem(item.title)">{{ item.title }}</router-link> -->

                    <!-- 移动端产品中心下拉 -->
                    <div class="mobile-dropdown">
                        <div v-for="item in navItems" :key="item.id">
                            <div class="dropdown-header nav-item">
                                <router-link :to="item.path" class="nav-title" @click.native="toggleMobileMenu">
                                    <h4 style="font-weight: 400;vertical-align: middle;margin-bottom:0px;">
                                        {{ item.title }}</h4>

                                </router-link>
                                <!-- @click.native="toggleMobileDropdown(item.id)" -->
                                <i class="el-icon-arrow-down" v-if="item.menuItem.length > 0" @click="toggleMobileDropdown(item.id)"
                                    :class="{ 'rotate-180': mobileDropdown === item.id }"></i>

                            </div>

                            <transition name="el-collapse-transition">
                                <div class="dropdown-content" v-show="mobileDropdown === item.id">
                                    <a v-for="subitem in item.menuItem" :key="subitem.id"  @click="jumpCategoryPage(subitem.id)" style="cursor:pointer"
                                        class="dropdown-item">{{ subitem.name }}</a>
                                </div>
                            </transition>

                        </div>
                        <!-- <div class="dropdown-header" @click="toggleMobileDropdown('products')">
                            <router-link to="/products" class="nav-item" @click.native="toggleMobileMenu">
                                <h4 style="font-weight: 400;vertical-align: middle;margin-bottom:0px;">产品中心</h4>
                                <i class="el-icon-arrow-down"
                                    :class="{ 'rotate-180': mobileDropdown === 'products' }"></i>
                            </router-link>

                        </div>
                        <transition name="el-collapse-transition">
                            <div class="dropdown-content" v-show="mobileDropdown === 'products'">
                                <router-link to="/products/temperature" class="dropdown-item"
                                    @click.native="toggleMobileMenu">温度仪表</router-link>
                                <router-link to="/products/pressure" class="dropdown-item"
                                    @click.native="toggleMobileMenu">压力仪表</router-link>
                                <router-link to="/products/flow" class="dropdown-item"
                                    @click.native="toggleMobileMenu">流量仪表</router-link>
                                <router-link to="/products/level" class="dropdown-item"
                                    @click.native="toggleMobileMenu">液位仪表</router-link>

                            </div>
                        </transition> -->
                    </div>
                </nav>

            </div>
        </transition>
    </div>

</template>

<script lang="js">


import { productApi, solutionApi, serviceApi } from '@/api'

export default {
    name: 'MobileNav',
    props: {
        showMobileNav: {
            type: Boolean
        },
        navItems: [],
    },
    watch: {
        showMobileNav(val) {
            if (!val) {
                this.mobileDropdown = null
            }
        }
    },
    data() {
        return {
            menuItem: [],
            mobileDropdown: false,
            currNav: null
        }
    },
    methods: {
        jumpHome(){
            this.$router.push({ path: "/index"})
        },
        jumpCategoryPage(id = null, childId = null) {
            //console.log("jumpCategoryPage   ",this.currNav ,id)
            if (this.currNav === 'products') {
                if (this.currNav === 'products' && !childId) {
                    this.$router.push({ path: "/products/category", query: { id: id } })
                } else {
                    this.$router.push({ path: "/products/productlist", query: { id: childId } })
                }
            }
            if (this.currNav === 'solutions') {
                if (this.currNav === 'solutions' && id) {
                    this.$router.push({ path: "/solutions/index", query: { id: id } })
                } else {
                    this.$router.push({ path: "/solutions/index" })
                }
            }
            if (this.currNav === 'services') {
                if (this.currNav === 'services' && id) {
                    this.$router.push({ path: "/services/index", query: { id: id } })
                } else {
                    this.$router.push({ path: "/services/index" })
                }
            }
            if (this.currNav === 'contact') {
                this.$router.push({ path: "/contact" })
            }
        },

        async getMenuItem(item) {
            try {
                let nav = item.id
                this.currNav = nav;
                this.mobileDropdown = this.mobileDropdown === item.id ? null : item.id
                this.menuItem = []
                //console.log(this.mobileDropdown, nav)

                if (nav === 'products') {
                    if (this.$store.state.topProductCategorys.length > 0) {

                        this.menuItem = this.$store.state.topProductCategorys
                    } else {
                        const [productsCategoryRes] = await Promise.all([
                            productApi.getProductCategories()
                        ])
                        productsCategoryRes.items || productsCategoryRes
                    }
                    //console.log("this.menuItem", this.menuItem)
                }
                if (nav === 'solutions') {

                    //console.log(this.$store.state.solutionCategorys)
                    if (this.$store.state.solutionCategorys.length > 0) {
                        this.menuItem = this.$store.state.solutionCategorys
                    } else {
                        const [solutionCategoryRes] = await Promise.all([
                            solutionApi.getCategorys()
                        ])

                        this.menuItem = solutionCategoryRes.items || solutionCategoryRes
                        this.$store.commit('SET_SOLUTIONCATEGORYS', solutionCategoryRes.items);
                    }
                }

                if (nav === 'services') {

                    //console.log(this.$store.state.serviceCategorys)
                    if (this.$store.state.serviceCategorys.length > 0) {
                        this.menuItem = this.$store.state.serviceCategorys
                    } else {
                        const [serviceCategoryRes] = await Promise.all([
                            solutionApi.getServiceCoategories()
                        ])

                        this.menuItem = serviceCategoryRes.items || serviceCategoryRes
                        this.$store.commit('SET_SERVICECATEGORYS', serviceCategoryRes.items);
                    }
                }


            } catch (error) {
                console.error('数据加载失败:', error)
            } finally {
                this.loading = false
            }



        },
        toggleMobileDropdown(menu) {
            
            this.currNav = menu;
            this.mobileDropdown = this.mobileDropdown === menu ? null : menu
        },

    }



}

</script>
<style lang="scss" scoped>
.mobile-menu-btn {
    display: none;
    background-color: #fff;
    border: none;
    font-size: 1.5rem;
    color: #0133a5;
    cursor: pointer;
    padding: 1.5rem 0.5rem;

    @media (max-width: 992px) {
        display: block;
    }
}


.mobile-sidebar {
    position: fixed;
    top: 0;
    left: 0;
    width: 280px;
    height: 100vh;
    background: #fff;
    z-index: 1100;
    box-shadow: 2px 0 10px rgba(0, 0, 0, 0.1);
    overflow-y: auto;

    .sidebar-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 1.5rem;
        border-bottom: 1px solid #eee;

        h3 {
            color: #0133a5;
            margin: 0;
            font-size: 1.3rem;
        }

        .close-btn {
            background: none;
            border: none;
            font-size: 1.5rem;
            color: #666;
            cursor: pointer;
        }
    }

    .mobile-nav {
        display: flex;
        flex-direction: column;
        padding: 1rem 0;
        width: 100%;
        justify-content: center;

        .nav-title {
            color: #333;
            text-decoration: none;
            font-size: 1.1rem;
            transition: background-color 0.3s;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;

            &:hover,
            &.router-link-active {
                color: var(--accent);
            }
        }

        .nav-item {
            padding: 1.2rem 1.5rem;
            width: 100%;
            color: #333;
            text-decoration: none;
            font-size: 1.1rem;
            transition: background-color 0.3s;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;

            &:hover,
            &.router-link-active {
                background-color: #f5f7fa;
                color: #0962d0;
            }
        }
    }
}

.main {
    flex: 1;
    padding: 0.1rem 0 0.1rem 0;
    background: transparent;
}


.overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1050;
}

/* 过渡动画 */
.slide-enter-active,
.slide-leave-active {
    transition: transform 0.3s ease;
}

.slide-enter,
.slide-leave-to {
    transform: translateX(-280px);
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s ease;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}

@media (max-width: 768px) {
    .footer {
        .footer-content {
            grid-template-columns: 1fr 1fr;
            text-align: left;
        }
    }
}

@media (max-width: 480px) {
    .footer {
        .footer-content {
            grid-template-columns: 1fr;
        }
    }
}

/* 响应式调整 */
@media (max-width: 992px) {
    .desktop-nav {
        .dropdown {
            .dropdown-menu {
                min-width: 160px;
                width: 100%;

                .dropdown-item {
                    padding: 8px 16px;
                    font-size: 0.95rem;
                }
            }
        }
    }
}


/* 桌面端下拉菜单样式 */
.dropdown {
    position: relative;
    cursor: pointer;

    &:hover {
        color: #0962d0;
        border-bottom: 1px solid #0962d09e;
    }

    .dropdown-menu {
        position: absolute;
        top: 100%;
        left: 0;
        min-width: 180px;
        background: #fff;
        border-radius: 4px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        padding: 8px 0;
        z-index: 100;
        margin-top: 5px;

        .dropdown-item {
            display: block;
            padding: 10px 20px;
            color: #606266;
            text-decoration: none;
            transition: all 0.3s;

            &:hover {
                color: #0962d0;
                background-color: #f5f7fa;
            }

            &.router-link-active {
                color: #0962d0;
                background-color: #ecf5ff;
            }
        }
    }
}

/* 移动端下拉菜单样式 */
.mobile-dropdown {
    .dropdown-header {
        display: flex;
        width: 100%;
        justify-content: stretch;
        align-items: stretch;
        color: #333;
        cursor: pointer;

        .rotate-180 {
            transform: rotate(180deg);
            transition: transform 0.3s;
        }
    }

    .dropdown-content {
        background-color: #f9f9f9;

        .dropdown-item {
            display: block;
            padding: 0.8rem 2rem;
            color: #555;
            text-decoration: none;

            &:hover {
                background-color: #f1f1f1;
            }

            &.router-link-active {
                color: #0962d0;
                background-color: #e6f0ff;
            }
        }
    }
}
</style>
